﻿import React from 'react';
import "./Footer.scss";
export function Footer(){
    
    return (
        <footer className="footer" data-testid="footer">
         <p className="footerText">Made in London with &#10084;&#65039; &copy; 2020 TechSwitch </p>
        </footer>
    );
}
